module.exports = __webpack_public_path__ + "img/addImage.aecdbfca.svg";